var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.152,
    height: 13.684,
    viewBox: "0 0 60.152 13.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iRobot_BrandGuidelines_2021",
    transform: "translate(-48.47 -34.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M84.781,39.184a3.391,3.391,0,0,0-3.4-4.3H77.26l-.681,3.2h3.1a.9.9,0,0,1,.9,1.15,1.478,1.478,0,0,1-1.386,1.13H76.05l4.212,7.785h4.41l-2.839-5.229a5.789,5.789,0,0,0,2.949-3.735",
    transform: "translate(-22.187 -0.515)",
    fill: "#6cb86a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M49.2,67.277l-.731,3.438h3.753l1.641-7.785c-2.282.08-4.079,1.6-4.662,4.347",
    transform: "translate(0 -23.08)",
    fill: "#6cb86a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M57.544,37.766A1.763,1.763,0,1,0,55.77,36a1.768,1.768,0,0,0,1.774,1.762",
    transform: "translate(-5.873)",
    fill: "#6cb86a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M319.762,34.88h-3.547l-1.824,8.663c-.538,2.536,1.273,4.889,5.514,4.889.037,0,.106-.006.106-.006l.72-3.387c-1.338.2-3.062-.3-2.753-1.75l.46-2.165h3.125l.645-3.035h-3.125Z",
    transform: "translate(-213.847 -0.515)",
    fill: "#6cb86a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M192.192,38.122a6.968,6.968,0,0,0-2.335.4l.774-3.651h-3.539l-1.787,8.4c-.632,2.974,1.383,5.155,4.72,5.155,3.737,0,6.212-1.6,6.916-4.932.681-3.213-1.688-5.376-4.75-5.376m1.251,5.153a2.708,2.708,0,0,1-2.794,2.165,1.662,1.662,0,0,1-1.781-2.251,2.526,2.526,0,0,1,2.714-2.077c1.467,0,2.131.886,1.862,2.163",
    transform: "translate(-109.985 -0.507)",
    fill: "#6cb86a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M256.7,51.5a6.755,6.755,0,0,0-6.916,5.155c-.673,3.18,1.4,5.155,4.67,5.155,4,0,6.351-1.975,7.012-5.155S260.044,51.5,256.7,51.5m1.214,5.153a2.672,2.672,0,0,1-2.763,2.165c-1.478,0-2.114-.88-1.83-2.194a2.61,2.61,0,0,1,2.751-2.133c1.467,0,2.114.886,1.842,2.163",
    transform: "translate(-161.842 -13.885)",
    fill: "#6cb86a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M127.386,51.5a6.755,6.755,0,0,0-6.916,5.155c-.673,3.18,1.4,5.155,4.67,5.155,4,0,6.351-1.975,7.012-5.155s-1.418-5.155-4.765-5.155m1.214,5.153a2.672,2.672,0,0,1-2.763,2.165c-1.478,0-2.114-.88-1.83-2.194a2.61,2.61,0,0,1,2.751-2.133c1.467,0,2.114.886,1.842,2.163",
    transform: "translate(-57.818 -13.885)",
    fill: "#6cb86a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M348.533,35.51a.821.821,0,1,1-.823.823.821.821,0,0,1,.823-.823m0,1.508a.684.684,0,0,0,0-1.369.684.684,0,1,0,0,1.369m.432-.235H348.8l-.285-.37h-.147v.37h-.147V35.86h.327c.252,0,.344.143.344.278a.263.263,0,0,1-.223.264Zm-.424-.8h-.176V36.3h.172c.135,0,.2-.055.2-.156,0-.066-.029-.154-.194-.154",
    transform: "translate(-240.725 -1.022)",
    fill: "#6cb86a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5755bebb.svg";
export { ForwardRef as ReactComponent };